export class AdvisingAbnormalTableHeaderUpdateBean {
  adNo: string;
  waitingReference: string | null;

  constructor() {
    this.adNo = "";
    this.waitingReference = null;
  }
}
